import cx from 'classnames'
import PropTypes from 'prop-types'
import React, { useEffect, useRef } from 'react'
import { gsap, Power1 } from 'gsap'
import { zeroPad } from 'react-countdown'

import withMemo from '../../decorators/withMemo'
import CountDown from '../../components/CountDown'
import { Header } from '../../components'

import useStyles from './styles'


const CountdownTemplate = (props) => {
  const classes = useStyles(props)
  const { className, countDownDate } = props

  // animations
  const $animatedWrapper = useRef()

  useEffect(() => {
    const timeline = gsap.timeline({ delay: 0.5 })

    if ($animatedWrapper.current) {
      const animatedChildren = Array.from($animatedWrapper.current.children)

      timeline.fromTo(animatedChildren, {
        opacity: 0,
      }, {
        duration: 0.5,
        opacity: 1,
        stagger: 0.6,
        ease: Power1.easeIn,
      })
    }
  }, [])

  return (
    <main className={cx(className, classes.container)}>
      <div
        ref={$animatedWrapper}
        className={classes.wrapper}
      >
        <Header className={classes.header} />
        {countDownDate && (
          <CountDown
            className={classes.countDown}
            countDownDate={countDownDate}
            countDownProps={{
              zeroPadTime: 2,
              renderer: (thisProps) => (
                `${zeroPad(thisProps.days)}:${zeroPad(thisProps.hours)}:${zeroPad(thisProps.minutes)}:${zeroPad(thisProps.seconds)}`
              ),
            }}
          />
        )}
      </div>
    </main>
  )
}

export const HomeTemplatePropTypes = {
  className: PropTypes.string,
  countDownDate: PropTypes.string,
}

CountdownTemplate.propTypes = HomeTemplatePropTypes

CountdownTemplate.defaultProps = {
  className: null,
  countDownDate: null,
}

export default withMemo()(CountdownTemplate)
